import { useSelector } from "react-redux";
import DealsAndPromotions from "../../../components/Operations/DealsAndPromotions/DealsAndPromotions";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";

const DealsAndPromotionsScreen = () => {
  const userData = useSelector(selectUserData);
  const hasDealsAndPromotionsScreenPermission = CheckPermissions(
    userData?.data?.products?.partners,
    "affiliate_accounts",
    "view_commission_plans",
  );

  return (
    <>
      {hasDealsAndPromotionsScreenPermission ? (
        <DealsAndPromotions />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default DealsAndPromotionsScreen;
